import React from 'react'
import { css } from '@emotion/css'
import OnboardingBlock from './OnboardingBlock'
import { Box } from '@mui/material'
import BlockTitle from './BlockTitle'
import useLearnPage from './useLearnPage'
import BlockWrapper from './BlolckWrapper'
import { OnboardingProvider } from '../context/OnboardingContext'

const LearnPageContent = () => {
  const { config } = useLearnPage()
  return (
    <div className={pageWrapperClass}>
      <div className={pageStack}>
        <OnboardingBlock />
        <Box display={'flex'} flexDirection='column' rowGap={2}>
          <BlockTitle
            title={'Make security awareness part of your workflow'}
            description={"Your team deserves the best protection out there. We're here to help!"}
          />
          {config.map((item, index) => (
            <BlockWrapper key={index} {...item} />
          ))}
        </Box>
      </div>
    </div>
  )
}

export default function LearnPage() {
  return (
    <OnboardingProvider>
      <LearnPageContent />
    </OnboardingProvider>
  )
}

const pageWrapperClass = css`
  height: 100vh;
  overflow-y: auto;
  width: 100%;
`

const pageStack = css`
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  padding: 36px 24px;
  width: 1089px;
  margin: auto;

  @media (max-width: 1276px) {
    width: 100%;
    min-width: 900px;
    margin: auto;
  }
`
